import { Text } from '@/ui-kit'
import { URLS } from './urls'

export const BanPage = () => {
  return (
    <>
      <Text className="mb-4 text-center" type="h3">
        Your account has been blocked.
      </Text>
      <Text className="colorWhiteToBlack mx-auto my-2 max-w-[280px] text-center">
        This was due to a violation of the{' '}
        <a className="hover:underline" href={URLS.TERMS_CONDITIONS} target="_blank" rel="noreferrer">
          Terms and Conditions.
        </a>
      </Text>
    </>
  )
}

export default BanPage
